module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABL0lEQVRYR+2XsUoEMRCG/4naCua0sdQNItgpWFsq2tlailx8iLt7iMshWFlaiiBYWVpoaSFZQRAF5di1VSEjK+7KNt4Ku8Qi6UImMx8fBP4QPC/yPB//C2Dy8EGOv79tO/o4f20v3tdpZ6YfR46wPjYhjl92557z3oWB1sDuMOMoPxCglaGOruuAmDbxsgNf5b0YtJHq6CzbFwDS2EcAs3UMHNWDgTjVSpUAWsaeMLBVXGbXG9Wo8rkQDEb3xwAuUq3WSgBTg7tNYnfwbeEm0Wqp8oAKhdLYSwCrAJ6YxF7anj8tAWQb2b/tgkQn0aqR1yGNZbDrJfsLhY3SoAAQDAQDwUAwEAwEA14NeA8kjUayr+gjOr9GMv+h1Hcsz/R4/ZhUCLaNlDSSfv9C6h3gE29RKjDVA8HgAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/drawtool/DRAWRECT_V.png
// module id = 9M8n
// module chunks = 18